/* eslint-disable postro4no/object-props */
export const gkParams = [
  ['General', [
    {
      checked: true, clickable: false, id: 1, name: 'Mins Played',
    },
    {
      checked: true, clickable: true, id: 173, name: 'Goals conceded',
    },
    {
      checked: true, clickable: true, id: 161, name: 'Goal Mistakes',
    },
    {
      checked: true, clickable: true, id: 162, name: 'Grave Mistakes',
    },
    {
      checked: true, clickable: true, id: 14, name: 'On-Ball Events',
    },
    {
      checked: true, clickable: true, id: 15, name: 'On-Ball Events +',
    },
    {
      checked: true, clickable: false, id: 1, name: 'On-Ball Events , %',
    },
    {
      checked: true, clickable: true, id: 17, name: 'On-Ball Events -',
    },
    {
      checked: true, clickable: false, id: 18, name: 'On-Ball Events - , %',
    },
    {
      checked: true, clickable: true, id: 19, name: 'Fouls',
    },
    {
      checked: true, clickable: true, id: 20, name: 'Fouls Suffered',
    },
    {
      checked: true, clickable: true, id: 21, name: 'Yellow Cards',
    },
    {
      checked: true, clickable: true, id: 22, name: 'Yellow-Red Cards',
    },
    {
      checked: true, clickable: true, id: 23, name: 'Red Cards',
    },
  ]],
  ['Shots / Saves', [
    {
      checked: true, clickable: true, id: 171, name: 'Opponent\'s shots',
    },
    {
      checked: true, clickable: true, id: 172, name: 'Opponent\'s shots on target',
    },
    {
      checked: true, clickable: true, id: 174, name: 'Saved shots',
    },
    {
      checked: true, clickable: false, id: 175, name: 'Saved shots , %',
    },
    {
      checked: true, clickable: true, id: 176, name: 'Super Saves',
    },
    {
      checked: true, clickable: true, id: 196, name: 'GK saves with bouncing',
    },
    {
      checked: true, clickable: true, id: 197, name: 'GK saves with bouncing +',
    },
    {
      checked: true, clickable: false, id: 198, name: 'GK saves with bouncing + , %',
    },
    {
      checked: true, clickable: true, id: 199, name: 'GK saves with bouncing -',
    },
    {
      checked: true, clickable: false, id: 200, name: 'GK saves with bouncing - , %',
    },
    {
      checked: true, clickable: true, id: 178, name: 'Goals conceded from penalty',
    },
    {
      checked: true, clickable: true, id: 179, name: 'Saved penalties',
    },
    {
      checked: true, clickable: false, id: 180, name: 'Saved penalties , %',
    },
  ]],
  ['GK Actions', [
    {
      checked: true, clickable: true, id: 181, name: 'GK Interceptions',
    },
    {
      checked: true, clickable: true, id: 182, name: 'GK Interceptions +',
    },
    {
      checked: true, clickable: false, id: 183, name: 'GK Interceptions , %',
    },
    {
      checked: true, clickable: true, id: 184, name: 'GK Interceptions -',
    },
    {
      checked: true, clickable: false, id: 185, name: 'GK Interceptions - , %',
    },
    {
      checked: true, clickable: true, id: 160, name: 'Clearances',
    },
  ]],
  ['Passes', [
    {
      checked: true, clickable: true, id: 35, name: 'Passes',
    },
    {
      checked: true, clickable: true, id: 36, name: 'Passes +',
    },
    {
      checked: true, clickable: false, id: 37, name: 'Passes +, %',
    },
    {
      checked: true, clickable: true, id: 38, name: 'Passes -',
    },
    {
      checked: true, clickable: false, id: 39, name: 'Passes - , %',
    },
    {
      checked: true, clickable: true, id: 40, name: 'Passes in challenge',
    },
    {
      checked: true, clickable: true, id: 41, name: 'Passes in challenge +',
    },
    {
      checked: true, clickable: false, id: 42, name: 'Passes in challenge + , %',
    },
    {
      checked: true, clickable: true, id: 43, name: 'Passes in challenge -',
    },
    {
      checked: true, clickable: false, id: 44, name: 'Passes in challenge - , %',
    },
    {
      checked: true, clickable: true, id: 186, name: 'GK Hand Passes',
    },
    {
      checked: true, clickable: true, id: 187, name: 'GK Hand Passes +',
    },
    {
      checked: true, clickable: false, id: 188, name: 'GK Hand Passes + , %',
    },
    {
      checked: true, clickable: true, id: 189, name: 'GK Hand Passes -',
    },
    {
      checked: true, clickable: false, id: 190, name: 'GK Hand Passes - , %',
    },
    {
      checked: true, clickable: true, id: 191, name: 'GK Goal Kick Passes',
    },
    {
      checked: true, clickable: true, id: 192, name: 'GK Goal Kick Passes +',
    },
    {
      checked: true, clickable: false, id: 193, name: 'GK Goal Kick Passes + , %',
    },
    {
      checked: true, clickable: true, id: 194, name: 'GK Goal Kick Passes -',
    },
    {
      checked: true, clickable: false, id: 195, name: 'GK Goal Kick Passes - , %',
    },
  ]],
  ['Passes by distance', [
    {
      checked: true, clickable: true, id: 55, name: 'Short Passes',
    },
    {
      checked: true, clickable: true, id: 56, name: 'Short Passes +',
    },
    {
      checked: true, clickable: false, id: 57, name: 'Short Passes + , %',
    },
    {
      checked: true, clickable: true, id: 58, name: 'Short Passes -',
    },
    {
      checked: true, clickable: false, id: 59, name: 'Short Passes - , %',
    },
    {
      checked: true, clickable: true, id: 60, name: 'Middle Passes',
    },
    {
      checked: true, clickable: true, id: 61, name: 'Middle Passes +',
    },
    {
      checked: true, clickable: false, id: 62, name: 'Middle Passes + , %',
    },
    {
      checked: true, clickable: true, id: 63, name: 'Middle Passes  -',
    },
    {
      checked: true, clickable: false, id: 64, name: 'Middle Passes - , %',
    },
    {
      checked: true, clickable: true, id: 65, name: 'Long Passes',
    },
    {
      checked: true, clickable: true, id: 66, name: 'Long Passes +',
    },
    {
      checked: true, clickable: false, id: 67, name: 'Long Passes + , %',
    },
    {
      checked: true, clickable: true, id: 68, name: 'Long Passes -',
    },
    {
      checked: true, clickable: false, id: 69, name: 'Long Passes - , %',
    },
    {
      checked: true, clickable: true, id: 97, name: 'Short Passes Received',
    },
    {
      checked: true, clickable: false, id: 98, name: 'Short Passes Received , %',
    },
    {
      checked: true, clickable: true, id: 99, name: 'Middle Passes Received',
    },
    {
      checked: true, clickable: false, id: 100, name: 'Middle Passes Received , %',
    },
    {
      checked: true, clickable: true, id: 101, name: 'Long Passes Received',
    },
    {
      checked: true, clickable: false, id: 102, name: 'Long Passes Received , %',
    },
  ]],
  ['Passes by side', [
    {
      checked: true, clickable: true, id: 70, name: 'Passes Forward',
    },
    {
      checked: true, clickable: true, id: 71, name: 'Passes Forward +',
    },
    {
      checked: true, clickable: false, id: 72, name: 'Passes Forward + , %',
    },
    {
      checked: true, clickable: true, id: 73, name: 'Passes Forward -',
    },
    {
      checked: true, clickable: false, id: 74, name: 'Passes Forward - , %',
    },
    {
      checked: true, clickable: true, id: 75, name: 'Passes Backward',
    },
    {
      checked: true, clickable: true, id: 76, name: 'Passes Backward +',
    },
    {
      checked: true, clickable: false, id: 77, name: 'Passes Backward +, %',
    },
    {
      checked: true, clickable: true, id: 78, name: 'Passes Backward -',
    },
    {
      checked: true, clickable: false, id: 79, name: 'Passes Backward - , %',
    },
    {
      checked: true, clickable: true, id: 80, name: 'Passes Sideways',
    },
    {
      checked: true, clickable: true, id: 81, name: 'Passes Sideways +',
    },
    {
      checked: true, clickable: false, id: 82, name: 'Passes Sideways + , %',
    },
    {
      checked: true, clickable: true, id: 83, name: 'Passes Sideways -',
    },
    {
      checked: true, clickable: false, id: 84, name: 'Passes Sideways - , %',
    },
    {
      checked: true, clickable: true, id: 103, name: 'Passes Forward Received',
    },
    {
      checked: true, clickable: false, id: 104, name: 'Passes Forward Received , %',
    },
    {
      checked: true, clickable: true, id: 105, name: 'Passes Backward Received',
    },
    {
      checked: true, clickable: false, id: 106, name: 'Passes Backward Received , %',
    },
    {
      checked: true, clickable: true, id: 107, name: 'Passes Sideways Received',
    },
    {
      checked: true, clickable: false, id: 108, name: 'Passes Sideways Received , %',
    },
  ]],
]
